import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ContentService {

  constructor(private http: HttpClient, private constantes: ConstantesService) { }

  getUsers(): Observable<any> {
    return this.http.get(environment.urlBase + 'users', this.constantes.httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/content.service.ts